import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export class CardResourceBack extends BaseCardData {
    cardEnum = CardEnum.ResourceBack
    cardTypeEnum = CardTypeEnum.Resource
    isCardBack = true
    imageFileName = 'card_rescardback'
    tipTitle: TranslationObject = {key: 'strings:game.cards.resource.back.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.resource.back.body'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardLumber extends BaseCardData {
    cardEnum = CardEnum.Lumber
    cardTypeEnum = CardTypeEnum.Resource
    isCardBack = false
    imageFileName = 'card_lumber'
    tipTitle: TranslationObject = {key: 'strings:game.cards.resource.lumber.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.resource.lumber.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardBrick extends BaseCardData {
    cardEnum = CardEnum.Brick
    cardTypeEnum = CardTypeEnum.Resource
    isCardBack = false
    imageFileName = 'card_brick'
    tipTitle: TranslationObject = {key: 'strings:game.cards.resource.brick.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.resource.brick.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardWool extends BaseCardData {
    cardEnum = CardEnum.Wool
    cardTypeEnum = CardTypeEnum.Resource
    isCardBack = false
    imageFileName = 'card_wool'
    tipTitle: TranslationObject = {key: 'strings:game.cards.resource.wool.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.resource.wool.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardGrain extends BaseCardData {
    cardEnum = CardEnum.Grain
    cardTypeEnum = CardTypeEnum.Resource
    isCardBack = false
    imageFileName = 'card_grain'
    tipTitle: TranslationObject = {key: 'strings:game.cards.resource.grain.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.resource.grain.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}

export class CardOre extends BaseCardData {
    cardEnum = CardEnum.Ore
    cardTypeEnum = CardTypeEnum.Resource
    isCardBack = false
    imageFileName = 'card_ore'
    tipTitle: TranslationObject = {key: 'strings:game.cards.resource.ore.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.resource.ore.body'}
    clickPopupType = CardClickPopupType.TradeWindow
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}
